import { HttpStatusCode } from '@angular/common/http';
import { Component, Input } from '@angular/core';

export enum CustomHttpStatusCode {
  BadRequest = 400,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
  GatewayTimeout = 504,
}

@Component({
  selector: 'app-table-data-request-error',
  templateUrl: './table-data-request-error.component.html',
  styleUrls: ['./table-data-request-error.component.scss'],
})
export class TableDataRequestErrorComponent {
  @Input() errorStatus: HttpStatusCode | null = null;

  protected readonly CustomHttpStatusCode = CustomHttpStatusCode;
}
